import { useEffect, useRef, useState } from 'react';

export default function HeroVideo() {
  const containerRef = useRef(null);
  const [shouldPlay, setShouldPlay] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldPlay(true);
          observer.disconnect(); // only trigger once
        }
      },
      { threshold: 0.5 }, // 50% of the video visible before triggering
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full max-w-3xl mx-auto aspect-video rounded-2xl overflow-hidden shadow-lg mb-16"
    >
      <iframe
        className="w-full h-full"
        src={
          shouldPlay ?
            'https://www.youtube.com/embed/zLCUHbIrIlw?autoplay=1&mute=1&rel=0'
          : 'https://www.youtube.com/embed/zLCUHbIrIlw?rel=0'
        }
        title="YouTube video player"
        allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
